import { render, staticRenderFns } from "./TicketStarbucks.vue?vue&type=template&id=8f630214"
import script from "./TicketStarbucks.vue?vue&type=script&lang=js"
export * from "./TicketStarbucks.vue?vue&type=script&lang=js"
import style0 from "./TicketStarbucks.vue?vue&type=style&index=0&id=8f630214&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports